// Experimenting with having a more centralised set of styles with individually
// exported properties

export const COLORS = {
  BRAND_PRIMARY: '#00AA81',
  OBEE_GREEN: '#78BEA1',

  // shades of gray
  BLACK: '#000000',
  GREEN_BLACK: '#15221C',
  JET: '#1A1919',
  CHARCOAL: '#313131',
  SMOKE: '#6E6E6D',
  NIMBUS: '#AEAEAE',
  SHARK: '#DCDCDB',
  CLOUD: '#F0F0F0',
  LIGHT_SHADE: '#F5F5F5',
  WHITE: '#FFFFFF',

  // Secondary colours
  SOUR_APPLE: '#C8F2A8',
  LEMON_DROP: '#F1ED89',
  GRAPE_SODA: '#C7C1E3',
  CLOUD_NINE: '#AFC7EC',

  // Backgrounds and accents
  DREAMY_SAGE: '#D8DDD3',
  PALE_MINT: '#F1F3F1',
  CALMING_FOG: '#F7F8F7',

  // Old junk
  DISABLED_GOAL_CARD: '#F9F9F9', // remove or rename
  YET_ANOTHER_GRAY_9: '#F2F2F2',
  YET_ANOTHER_GRAY_10: '#575757',
  OLIVE: '#28524B', // probs remove
  OLIVE_TEXT: '#42756C', // probs remove
  OLIVE_2: '#386D64', // probs remove
  OLIVE_4: '#86AEA6', // probs remove
  OLIVE_5: '#E1EAE8', // probs remove
  LINEN: '#F5F2ED', // change
  LINEN_DARK: '#DFD7C8', // change
  ALABASTER: '#EFEBE4',
  ERROR_RED: '#DA5A5A',
};

export const FONT_SIZES = {
  // Old styles that need refactoring
  // TODO should just be able to replace these in the theme
  HXL: '56px',
  H1: '32px',
  H2: '28px',
  H3: '24px',
  H4: '18px',
  H5: '15px',

  DEFAULT: '15px',
  L: '18px',
  M: '15px',
  S: '12px',
};

export const LINE_HEIGHTS = {
  XS: '10px',
  S: '14px',
  M: '16px',
  L: '20px',
  L2: '22px', // Since there's no consistency yet
  L3: '24px', // Since there's no consistency yet
  XL: '28px',
  XXL: '32px',
  '3XL': '34px',
  '4XL': '40px',
};

export const FONT_WEIGHTS = {
  REGULAR: 400,
  MEDIUM: 500,
  BOLD: 700,
  BLACK: 900,
};

const theme = {};

export default theme;
